import React, { useEffect, useState } from 'react'
import './eval-page.styles.scss'

import { Routes, Route, Navigate } from 'react-router-dom'

import Header from '@/components/header/header.component'
// import Header from '@/components/header/header.component'

import Footer from '@/components/footer/footer.component'
import { Sources } from '@/forms/formTypes'
import Header2025 from '../../components/header-2025/header-2025.component'
import { useSelector } from 'react-redux'
import CpduPrintable from '../../components/HOME/cpdu-printable/cpdu-printable.component'
import EvalForm from '../../components/EVAL/eval-form/eval-form.component'


const EvalPage = () => {

	const screenSize = useSelector(state => state.listsData.screenSize);
	const [ platform, setPlatform ] = useState(null);

	useEffect(() => {
		const header = document.getElementsByClassName('header-2025')[0]
		console.log('platform', platform)
		if (platform) {
			header.classList.add(platform)
		} else {
			header.classList.remove('eln')
			header.classList.remove('ipa')
		}
	}, [platform])

	return (
		<div className={`eval-page ${screenSize}`}>
			<Header2025 platform={platform} />
			<Routes>
				<Route path='' element={<Navigate to="/" />} ></Route>
				<Route path='/:evalPath' element={
					<div className='eval-page-content'>
						<EvalForm />
					</div>
				}></Route>
			</Routes>

			<Footer platform={platform} />
		</div>
	)
}

export default EvalPage